import { Link, useLocation } from "react-router-dom";

const Menu = () => {
  const { pathname } = useLocation();

  return (
    <ul className="hidden md:flex items-center space-x-6">
      <Link
        className={`cursor-pointer ${pathname === "/" && "font-semibold"}`}
        to="/"
        id="lws-bookStore"
      >
        <li>Book Store</li>
      </Link>
      <Link
        className={`cursor-pointer ${pathname === "/add" && "font-semibold"}`}
        to="/add"
        id="lws-addBook"
      >
        <li>Add Book</li>
      </Link>
    </ul>
  );
};

export default Menu;
